import { observable, action } from 'mobx';

class JoyrideStore {
  @observable key = new Date(); // This field makes the tour to re-render when we restart the tour
  @observable run = false;
  @observable loading = false;
  @observable stepIndex = 0;
  @observable steps = [];
  @observable jRID = null;

  @action
  restart() {
    this.stepIndex = 0;
    this.run = true;
    this.loading = false;
    this.key = new Date();
  }

  @action.bound
  setID(id) {
    this.jRID = id;
  }

  @action.bound
  start() {
    this.run = true;
  }

  @action.bound
  stopRun() {
    this.run = false;
  }

  @action.bound
  setSteps(newSteps) {
    this.steps = newSteps;
  }
  @action.bound
  setStepIndex(index) {
    this.stepIndex = index;
  }
}

export default JoyrideStore;
